import { create } from 'zustand'

interface AppState {
  selectedYear: string
  setSelectedYear: (year: string) => void
  darkMode: boolean
  toggleDarkMode: () => void
}

function getInitialDarkMode(): boolean {
  if (typeof window === 'undefined') return false
  const stored = localStorage.getItem('taxes-viz-dark-mode')
  if (stored !== null) return stored === 'true'
  return window.matchMedia('(prefers-color-scheme: dark)').matches
}

function applyDarkMode(dark: boolean) {
  document.documentElement.classList.toggle('dark', dark)
  localStorage.setItem('taxes-viz-dark-mode', String(dark))
}

export const useAppStore = create<AppState>((set) => ({
  selectedYear: '2023',
  setSelectedYear: (year) => set({ selectedYear: year }),
  darkMode: getInitialDarkMode(),
  toggleDarkMode: () =>
    set((s) => {
      const next = !s.darkMode
      applyDarkMode(next)
      return { darkMode: next }
    }),
}))
